<template>
  <div class="container" :class="wrapper ? 'wrapper' : ''">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    /**
     * add wrapper class to container
     */
    wrapper: {
      required: false,
      type: Boolean,
      default: true,
    },
  },
};
</script>
